import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import ProjectsDetailList from "../components/projectsDetailList/projectsDetailList";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-container">
						<div className="title projects-title">
							Projects
						</div>

						<div className="subtitle projects-subtitle">
						Over the years, I’ve had the pleasure of working on a variety of projects that combine my love for technology and my mission to make life easier for users. Each project is a little piece of my passion for creating customer-friendly solutions. While I’m proud of how far they’ve come, I know there’s always room for improvement. I’m always eager to exchange ideas, receive feedback, and enhance these projects with new perspectives. Feel free to join me in making these contributions even better!
						</div>

						<div className="projects-list">
							<ProjectsDetailList />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
